import Button from "./cta/Button";
import { LoginConstants } from "../../constants/constants";
import { useDispatch } from "react-redux";
import { AppDispatch } from "../../store/store";
import { verifyFaceRecognitionAsync } from "../../store/thunks/userThunk";
import RemoveIcon from "../../assets/images/removeIcon";

interface ModalProps {
  setCapturedImage: any;
  setConfirmedImage: any;
  videoRef: any;
  capturedFileImage?: any;
  captureImage: any;
  capturedImage: any;
  startCamera: any;
  setIsCameraActive: any;
  buttonText: string;
  popUpMsg: string;
  popUpTitle: string;
  isOpen: boolean;
  isVerifyImage: boolean;
  onClose: () => void;
  addImageToUserInfo: () => void;
  icon?: any;
  cancelIcon?: any;
  closeCamera: () => void;
}

const CameraPopup = ({
  setCapturedImage,
  setConfirmedImage,
  videoRef,
  captureImage,
  capturedFileImage,
  capturedImage,
  startCamera,
  setIsCameraActive,
  isVerifyImage,
  addImageToUserInfo,
  closeCamera,
  onClose,
  buttonText,
}: ModalProps) => {
  const dispatch = useDispatch<AppDispatch>();

  const verifyImage = () => {
    try {
      let formData = new FormData();
      formData.append("face", capturedFileImage);
      dispatch(verifyFaceRecognitionAsync(formData));
      setConfirmedImage(true);
    } catch (error: any) {
      console.error("Error publishing announcement:", error.message);
    }
  };
  return (
    <>
      <div className="fixed z-15 inset-0 ">
        <div className="flex items-start justify-center min-h-screen pt-4 px-4 pb-20 text-center sm:block sm:p-0">
          <div className="fixed inset-0 transition-opacity" aria-hidden="true">
            <div className="absolute inset-0 bg-blackColor bg-opacity-35 "></div>
          </div>

          <span
            className="hidden sm:inline-block sm:align-middle sm:h-screen"
            aria-hidden="true"
          >
            &#8203;
          </span>
          <div
            className="inline-block align-bottom bg-whiteColor rounded-lg text-left overflow-hidden shadow-xl transform transition-all sm:my-8 sm:align-top sm:max-w-lg sm:w-full"
            role="dialog"
            aria-modal="true"
            aria-labelledby="modal-headline"
          >
            <div
            data-testid="close-button"
              className="flex justify-end bg-primary py-2 px-4"
              onClick={() => {
                onClose();
                closeCamera();
                setIsCameraActive(false);
                setCapturedImage(undefined);
              }}
            >
              <RemoveIcon />
            </div>
            <div></div>
            <div className="w-full max-w-lg mx-auto">
              {capturedImage ? (
                <img
                  src={capturedImage}
                  alt="Captured"
                  className="object-cover  h-full w-full rounded-md" // Adjusted class here
                />
              ) : (
                <video
                  ref={videoRef}
                  autoPlay
                  playsInline
                  className="w-full h-full object-cover rounded-md" // Consistent class for video
                />
              )}
            </div>

            <div className="flex justify-center w-full items-center mt-[2vh]">
              <Button
                handleClick={() => {
                  startCamera();
                  captureImage();
                }}
                buttonText={
                  capturedImage
                    ? LoginConstants.Retake
                    : LoginConstants.CaptureImage
                }
                className={`${
                  buttonText
                    ? "px-[10vw] md:px-[4vw] py-[2vh]"
                    : "px-[2vw] py-[2vh]"
                }
                  "  ml-[1vw] mb-2 quickLinksDescription text-white focus:outline-none bg-primary rounded-lg border border-black focus:z-10 focus:ring-4 focus:ring-gray-100 "
                `}
              />
              {capturedImage && (
                <Button
                  handleClick={() => {
                    {
                      isVerifyImage && verifyImage();
                    }
                    addImageToUserInfo();
                    setIsCameraActive(false);
                  }}
                  buttonText={buttonText ? buttonText : LoginConstants.Confirm}
                  className={`${
                    buttonText
                      ? "py-[2vh] px-[2vw] ml-[4vw] md:ml-[1vw] mb-2 quickLinksDescription text-white focus:outline-none bg-primary rounded-lg border border-black focus:z-10 focus:ring-4 focus:ring-gray-100 "
                      : "px-[2vw] w-[20vw] py-[2vh]    overflow-hidden ml-[1vw]  md:w-[8vw] mb-2 body1 text-white focus:outline-none bg-primary rounded-lg border border-black focus:z-10 focus:ring-4 focus:ring-gray-100"
                  }"
                  `}
                />
              )}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
export default CameraPopup;
